module.exports = __webpack_public_path__ + "static/img/Inspection1.748bddd1.png";